const footer = () => {
    return (
        <div className="container bg-dark">
            <div className="row">
                <div className="col text-center">
                    <p> Mi primer desarrollo en React JS </p>
                </div>
            </div>
        </div>
    )
}
export default footer;